import {
  IExecutionHistory,
  PathwaySelectionsActions,
  PathwaySelectionsActionTypes
} from '../actions/pathway-selections.actions';

export interface IPathwaySelectionsState extends IExecutionHistory {
  tpNote: string;
}

const pathwaySelectionsInitialState: IPathwaySelectionsState = {
  history: [],
  tpNote: ''
};

export function pathwaySelectionsReducer(state = pathwaySelectionsInitialState, action: PathwaySelectionsActions): IPathwaySelectionsState {
  switch (action.type) {
    case PathwaySelectionsActionTypes.UpdateExecutionPathInStore:
      return Object.assign({ }, state, { history: [...action.payload.history]});
    case PathwaySelectionsActionTypes.UpdateTPNoteInStore:
      return Object.assign({ }, state, { tpNote: action.payload});
    default:
      return state;
  }
}
